var map = {
	"./bitcoin.svg": "386b",
	"./coinbase.svg": "8e7e",
	"./dollar.svg": "c71a",
	"./dollar2.svg": "b642",
	"./euro.svg": "c25f",
	"./fiat.svg": "74b3",
	"./gbp.svg": "f97c",
	"./mwk.svg": "3480",
	"./ngn.svg": "7f14",
	"./plus-icon.svg": "9f8c",
	"./pyusd.svg": "5bca",
	"./sgd.svg": "0a2d",
	"./small-logo-icon.svg": "ca92",
	"./testBTC.svg": "d286",
	"./usdc.svg": "dee4",
	"./usdt.svg": "b2b9",
	"./zar.svg": "4919"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6c87";